/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setVerticalTypeEnablement} from '../api'

export const useMutationSetVerticalTypeEnablement = createReactQueryMutationHook('setVerticalTypeEnablement', setVerticalTypeEnablement)
